import React from 'react';
import { Route, Switch } from 'react-router-dom';
import './stylesheet/styles.css';
// import './stylesheet/App.css';
// import "./App.scss";
import { Shipment } from './components/Shipment';
import { Search } from './components/Search';
import { ShowResults } from './components/Results';
import { ListResult } from './components/ListResults'


import { GlobalProvider } from './context/GlobalState';

function App() {
  return (
    <GlobalProvider>
      <Switch>
        <Route path="/" component={Search} exact />
        {/* <Route path="/search" component={Search} exact /> */}
        <Route path="/results" component={ShowResults} exact />
        <Route path="/track" component={Shipment} exact />
        <Route path="/tracking/:id" component={ListResult} exact />
      </Switch>
    </GlobalProvider>
  );
}

export default App;
